import {resolveBackground} from '#core/utils/color-utils.js';
import {merge} from '#core/utils/config-utils.js';

import {generatePrimaryButton, generateTertiaryButton} from '#core/application/modules/tiles/button/index.js';

export function onboardingFactory(PALETTE) {
    const {FONT} = PALETTE;

    return {
        FeaturePresenter: {
            container: {
                style: {
                    padding: '32px 16px 0px 16px',
                },
            },
            title: {
                style: {
                    flexBasis: 32,
                    fontSize: FONT.SIZE_LARGE,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    lineHeight: '18px',
                    padding: '16px 0 0 0',
                    ...PALETTE.FEATURE_PRESENTER_TITLE_TEXT,
                },
            },
            description: {
                style: {
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_NORMAL,
                    lineHeight: '17px',
                    padding: '16px 16px 24px 16px',
                    ...PALETTE.FEATURE_PRESENTER_DESCRIPTION_TEXT,
                },
            },
            navigationControllersContainer: {
                itemSpacing: '24px',
                style: {
                    flexBasis: '140px',
                },
            },
            progress: {
                container: {
                    style: {
                        justifyContent: 'center',
                    },
                },
                activeDot: {
                    style: {
                        base: {
                            ...resolveBackground(PALETTE.FEATURE_PRESENTER_ACTIVE_DOT_COLOR),
                            borderRadius: '50%',
                            margin: '0 2px',
                        },
                    },
                },
                inactiveDot: {
                    style: {
                        base: {
                            ...resolveBackground(PALETTE.FEATURE_PRESENTER_INACTIVE_DOT_COLOR),
                            borderRadius: '50%',
                            margin: '0 2px',
                            opacity: '50%',
                        },
                    },
                },
            },
            nextButton: {
                config: generatePrimaryButton(PALETTE.FEATURE_PRESENTER_NEXT_BUTTON),
            },
            skipButton: {
                config: merge(generateTertiaryButton(PALETTE.FEATURE_PRESENTER_SKIP_BUTTON), {
                    style: {
                        base: {
                            margin: '16px 0 0 0',
                        },
                    },
                }),
            },
            finishButton: {
                config: generatePrimaryButton(PALETTE.FEATURE_PRESENTER_FINISH_BUTTON),
            },
        },
    };
}
